// Exponential backoff with a rising jitter band: each retry waits a random time
// between the previous attempt's ceiling and this one's (baseMs * 2^attempt,
// capped at capMs), so the ramp only grows. First attempt's floor is minMs.

export interface BackoffOptions {
	baseMs: number;
	capMs: number;
	/** Floor for the first attempt, which has no predecessor. Defaults to 0. */
	minMs?: number;
}

/** Jittered delay before the retry after a failed attempt (0-indexed). */
export function backoffDelayMs(
	attempt: number,
	{ baseMs, capMs, minMs = 0 }: BackoffOptions
): number {
	const ceiling = Math.min(capMs, baseMs * 2 ** attempt);
	const floor =
		attempt === 0 ? Math.min(minMs, ceiling) : Math.min(capMs, baseMs * 2 ** (attempt - 1));
	return floor + Math.random() * (ceiling - floor);
}
